const apiUrls = require('../../constants/apiUrls');

const equipmentOptions = {
    key: 'equipmentOptions',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.EQUIPMENT_OPTIONS_URL}?jobNumber=${request.workOrderNumber}&billingSystem=${request.billingSystem}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }
    ]
};

export default equipmentOptions;


// WEBPACK FOOTER //
// ./src/store/order-details-config/equipmentOptions.js